import {
    SET_IS_META,
    SET_CURRENT_PAGE,
} from 'od-modules/secure_store/actions';

export default function dpPriceFees(state = {}, action) {
    switch (action.type) {
        case SET_IS_META:
            return Object.assign({}, state, {isMeta: action.entry});
        case SET_CURRENT_PAGE:
            return Object.assign({}, state, {page: action.entry});
        default:
            return state;
    }
}
